











































import { Component, Prop, Ref, VModel, Vue } from 'vue-property-decorator'

import FilesList from '../FilesList/FilesList.vue'
import FileTypeFabric from '../logic/file-type-fabric'
import { FileData } from '../types'

@Component({
  components: {
    FilesList,
  },
})
export default class BaseFileInput extends Vue {
  @VModel() model!: Array<File> | File | null

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ type: Boolean, default: false }) readonly multiple!: boolean

  @Prop() readonly availableMimeTypes!: Array<string>

  @Ref('droppable-zone') readonly droppableZone!: HTMLElement

  @Ref('fileInput') readonly fileInput!: HTMLInputElement

  isDragoverListenerActivated = false

  isOnDroppableZone = false

  get filesModel(): Array<File> {
    return this.model as Array<File>
  }

  set filesModel(value: Array<File>) {
    this.model = value
  }

  get fileModel(): File | null {
    return this.model as File
  }

  set fileModel(value: File | null) {
    this.model = value
  }

  get filesData(): Array<FileData> {
    const fileTypeFabric: FileTypeFabric = new FileTypeFabric()
    const singleFileData: Array<FileData> = this.fileModel ? [ fileTypeFabric.createFromFile(this.fileModel) ] : []
    // eslint-disable-next-line multiline-ternary
    return this.multiple
      // eslint-disable-next-line multiline-ternary,id-blacklist
      ? this.filesModel.map((file) => fileTypeFabric.createFromFile(file))
      : singleFileData
  }

  onInputChange(e: InputEvent): void {
    const el: HTMLInputElement = e.target as HTMLInputElement
    // eslint-disable-next-line id-blacklist
    const files: Array<File> = Array.from(el.files || []).filter((file) => {
      if (this.availableMimeTypes) {
        // eslint-disable-next-line id-blacklist
        return this.availableMimeTypes.includes(file.type)
      }
      return true
    })
    if (this.multiple) {
      this.filesModel = [ ...this.filesModel, ...files ]
    } else {
      // eslint-disable-next-line prefer-destructuring
      this.fileModel = files[0]
    }
  }

  removeFile(fileIndex: number): void {
    if (this.multiple) {
      this.filesModel.splice(fileIndex, 1)
    } else {
      this.fileModel = null
    }
  }

  removeAllFiles(): void {
    this.fileModel = null
  }

  inputFromFilesData(): void {
    const singleFile: File | null = this.filesData[0].file || null
    if (this.multiple) {
      this.filesModel = this.filesData.map((fileData) => fileData.file as File)
    } else {
      this.fileModel = singleFile
    }
  }

  // eslint-disable-next-line max-statements
  updated(): void {
    if (!this.isDragoverListenerActivated) {
      const DRAGOVER_ACTIVE_CLASS = 'dragover-active'

      const addActiveClass = (): void => {
        this.droppableZone.classList.add(DRAGOVER_ACTIVE_CLASS)
        this.isOnDroppableZone = true
      }

      const removeActiveClass = (): void => {
        this.droppableZone.classList.remove(DRAGOVER_ACTIVE_CLASS)
        this.isOnDroppableZone = false
      }

      this.droppableZone.addEventListener('dragenter', addActiveClass, false)
      this.droppableZone.addEventListener('dragover', addActiveClass, false)

      this.droppableZone.addEventListener('dragleave', removeActiveClass, false)
      this.droppableZone.addEventListener('dragend', removeActiveClass, false)
      this.droppableZone.addEventListener('drop', removeActiveClass, false)

      this.droppableZone.addEventListener('drop', (e) => {
        this.droppableZone.classList.remove(DRAGOVER_ACTIVE_CLASS)
        if (e.dataTransfer !== null) {
          this.fileInput.files = e.dataTransfer.files
        }
      }, false)

      this.isDragoverListenerActivated = true
    }
  }
}
